import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from "../views/Home.vue"
import Search from "../views/Search.vue"
import Download from "../views/Download.vue"

const routes = [
	{
		path: '/other/home',
		component: Home
	},
	{
		path: '/other/search',
		component: Search
	},
	{
		path: '/other/download',
		component: Download
	},
	{
		path: '/other/',
		redirect: '/other/home'
	}
]

var router = new VueRouter({
	routes: routes,
	mode: 'history'
})

export default router
